import styled from "styled-components";

import Body from "../../../../shared/styles/typography/Body.styled";

interface ShowFlightInfoButtonProps {
  icon: string;
  isFlightShown: boolean;
  direction: "ltr" | "rtl";
}

const ShowFlightInfoButton = styled.button<ShowFlightInfoButtonProps>`
  border: none;
  background: none;
  position: relative;
  cursor: pointer;
  width: 100%;
  text-align: ${({ direction }) => (direction === "ltr" ? "left" : "right")};
  padding: 0;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

  &::after {
    position: absolute;
    top: 0;
    right: ${({ direction }) => (direction === "ltr" ? "0" : "initial")};
    left: ${({ direction }) => (direction === "rtl" ? "0" : "initial")};
    content: ${({ icon }) => `url(${icon})`};
    transform: ${({ isFlightShown }) =>
      isFlightShown ? "rotate(180deg)" : "none"};
  }

  ${Body} {
    color: ${({ theme }) => theme.colors.showMoreLink};
  }
`;

export default ShowFlightInfoButton;
